import type { TFunction } from "i18next";
import { MenuItemDto } from "src/api/client-api/menu/useMenuAdmin";

export const translatedMenuLabel = (t: TFunction, item: Pick<MenuItemDto, "label" | "i18nKey">): string =>
    item.i18nKey ? t(item.i18nKey, item.label) : item.label;
